import React from 'react';
import { Toaster } from 'react-hot-toast';
import { Header } from './Header';
import { Footer } from './Footer';
import { useCartStore } from '../../store/cart.store';
import { WhatsAppFloatingButton } from '../whatsapp/WhatsAppFloatingButton';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isOpen } = useCartStore();

  return (
    <div className="min-h-screen flex flex-col">
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#10B981',
              secondary: '#fff',
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#EF4444',
              secondary: '#fff',
            },
          },
        }}
      />
      <Header />
      {/* Contenedor del contenido con padding-top para el header fijo y padding-right cuando el carrito está abierto */}
      <div 
        className={`flex-1 transition-all duration-300 ease-in-out pt-20 md:pt-[116px] ${
          isOpen ? 'lg:pr-[420px]' : ''
        }`}
      >
        {children}
      </div>
      <Footer />
      <WhatsAppFloatingButton />
    </div>
  );
};

export default Layout;
